import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { sanityClient, urlFor } from "../lib/sanityClient";
import "../styles/Benefits.css";

const QUERY = `*[_type == "benefitsSection"][0]{
  heading, benefitCards
}`;

const Benefits = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(QUERY).then(setData);
  }, []);

  if (!data) return null;

  const benefits = data.benefitCards || [];

  return (
    <section className="benefits-section" id="benefits">
      <div className="benefits-radial" />
      <div className="benefits-sidebar left" />
      <div className="benefits-sidebar right" />

      <motion.div
        className="benefits-wrapper"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h2 className="benefits-heading">{data.heading}</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const isHovered = hoveredIndex === index;
            const isBlurred = hoveredIndex !== null && hoveredIndex !== index;
            const isBottomCard = index === 2 || index === 3;

            return (
              <motion.div
                key={benefit._key}
                className={`animated-border-card ${
                  isBlurred ? "blurred" : ""
                } ${isHovered ? "hovered" : ""} ${
                  isBottomCard ? "lift-on-hover" : ""
                }`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                animate={
                  isHovered
                    ? isBottomCard
                      ? { scale: 1.05, y: -8 }
                      : { scale: 1.05 }
                    : { scale: 1, y: 0 }
                }
                transition={{ type: "spring", stiffness: 300 }}
              >
                <div className="benefit-card">
                  <motion.img
                    src={urlFor(benefit.icon).url()}
                    alt={`${benefit.title} icon`}
                    className="benefit-icon"
                    animate={{
                      scale: [1, 1.3, 1],
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 2.5,
                      ease: "easeInOut",
                    }}
                  />
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description" style={{ whiteSpace: "pre-line" }}>{(benefit.description || '').replace(/\\n/g, '\n')}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
};

export default Benefits;
